import React from 'react';
import Helmet from 'react-helmet';
import DefaultLayout from '../layouts';
import PageBlocks from '../components/PageBlocks';

export default function DynamicLandingPage({
  content,
  meta_title,
  meta_description,
  noindex,
  location,
  disclaimer,
}) {
  return (
    <DefaultLayout
      title={meta_title}
      location={location}
      noFade
      fixedNav
      disclaimer={disclaimer}
    >
      <Helmet titleTemplate={false}>
        <title>{meta_title}</title>
        <meta name="description" content={meta_description} />
        <meta property="og:title" content={meta_title} />
        <meta property="og:description" content={meta_description} />
        {noindex ? <meta name="robots" content="noindex" /> : null}
      </Helmet>
      {content.map((block, i) => (
        <PageBlocks key={i} isFirst={i === 0} type={block.type} block={block} />
      ))}
    </DefaultLayout>
  );
}
